import dayjs, { ManipulateType, QUnitType } from 'dayjs';

interface CustomFormats {
  [key: string]: { [key: string]: string };
}

const customFormats: CustomFormats = {
  ko: {
    L1: 'YYYY.MM.DD',
    L2: 'YYYY-MM-DD',
    L3: 'MM.DD',
    L4: 'YYYYMMDD',
    L5: 'YYYY.MM.DD HH:mm',
    L6: 'YYYY년 MM월 DD일',
  },
  en: {
    L1: 'MM/DD/YYYY',
    L2: 'MM-DD-YYYY',
    L3: 'MM/DD',
    L4: 'YYYYMMDD',
    L5: 'MM/DD/YYYY HH:mm',
    L6: 'MMMM DD, YYYY',
  },
};
const formatList = ['L1', 'L2', 'L3', 'L4', 'L5', 'L6'];

export const now = dayjs();
export const today = now.format('YYYY.MM.DD');
export const todayNumber = parseInt(now.format('YYYYMMDD'), 10);
export const year = dayjs().year();

export const getDate = (date: string) => dayjs(date.replaceAll('.', '-'));

export const formatDate = (
  date: string | Date,
  type: number = 0,
  lang?: string
) => {
  const locale = document.documentElement.lang.split('-')[0];
  const formatString = customFormats[lang || locale][formatList[type]];
  const formattedDateString = date
    ? dayjs(
        typeof date === 'string'
          ? date.replaceAll('.', '-')
          : date.toISOString()
      ).format(formatString)
    : '';

  return formattedDateString;
};

// export const isBefore = (date: string) => dayjs().isBefore(dayjs(date));

export const getDiff = (d1: string, d2?: string, unit: QUnitType = 'day') => {
  const date1 = dayjs(d1?.replaceAll('.', '-'));
  const date2 = d2
    ? dayjs(d2?.replaceAll('.', '-'))
    : dayjs(d2).format('YYYY-MM-DD');

  return date1.diff(date2, unit);
};

export const addDays = (
  amount: number,
  unit: ManipulateType | undefined = 'day'
) => now.add(amount, unit);

export const getAge = (birthDate: string | Date) => {
  return now.diff(birthDate, 'year');
};
